import axios from 'axios';

const datafeedApi = () => {
  switch (import.meta.env.VITE_API_ENV || 'staging') {
    case 'development':
      return `https://42ouknkf80.execute-api.us-east-1.amazonaws.com/default`;
    case 'staging':
      return `https://42ouknkf80.execute-api.us-east-1.amazonaws.com/default`;
    default:
      return `https://d4ctpbgv4a.execute-api.us-east-1.amazonaws.com/production`;
  }
};

/**
 *  usePayoutApi is a hook that returns a reusable axios instance with auth
 * @returns {AxiosInstance}
 */
export const DatafeedApi = axios.create({
  baseURL: datafeedApi(),
  withCredentials: false,
});
